<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_course") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="6"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
            :acceptVideo="true"
            required
            :preSelectedImage="data.image?.path"
          />
          <base-image-upload-input
            col="6"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_iden')"
            @selectImage="selectVideo"
            :preSelectedImage="data.video?.path"
            :acceptVideo="true"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.desc_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.desc_en"
            required
          />
          <base-select-input
            col="6"
            :optionsList="academic_stages"
            :placeholder="$t('PLACEHOLDERS.academic_stage')"
            v-model="data.academic_stage"
          />
          <base-select-input
            col="6"
            :optionsList="academic_years"
            :placeholder="$t('PLACEHOLDERS.academic_year')"
            v-model="data.academic_year"
          />
          <base-select-input
            col="6"
            :optionsList="levels"
            :placeholder="$t('PLACEHOLDERS.course_level')"
            v-model="data.level"
          />
          <div class="row justify-content-center">
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>

            <div v-for="(item, index) in skills" :key="'l' + index">
              <div class="item d-flex align-items-center">
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.skill_ar')"
                  v-model.trim="item.ar"
                />
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.skill_en')"
                  v-model.trim="item.en"
                />

                <div class="all_actions" v-if="skills?.length > 1">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeRow(index)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditBank",
  
  watch: {
    "data.academic_stage"(newVal) {
      if (this.isInitialCourseChange) {
        this.isInitialCourseChange = false;
        return;
      }

      this.data.academic_year = null;

      if (newVal) this.getAcademicYears(newVal.id);
    },
  },
  data() {
    return {
      isWaitingRequest: false,
      skills: [],
      isInitialCourseChange: true,

      academic_years: [],
      academic_stages: [],
      data: {
        academic_year: null,
        academic_stage: null,
        name_ar: null,
        level: null,
        name_en: null,
        image: {
          file: null,
          path: null,
        

},
        video: {
          file: null,
          path: null,
        },
        desc_ar: null,
        desc_en: null,
        active: true,
        count_use: null,
        active: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    levels() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.beginner"),
          value: "beginner",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.intermediate"),
          value: "intermediate",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.advanced"),
          value: "advanced",
        },
      ];
    },
  },

  methods: {
    addRow() {
      this.skills.push({ ar: "", en: "" });
    },
    removeRow(index) {
      this.skills.splice(index, 1);
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.desc_ar) {
        REQUEST_DATA.append("description[ar]", this.data.desc_ar);
      }
      if (this.data.desc_en) {
        REQUEST_DATA.append("description[en]", this.data.desc_en);
      }
      if (this.data.academic_stage) {
        REQUEST_DATA.append("academic_stage_id", this.data.academic_stage.id);
      }
      if (this.data.academic_year) {
        REQUEST_DATA.append("academic_year_id", this.data.academic_year.id);
      }
      if (this.data.level) {
        REQUEST_DATA.append("level", this.data.level.value);
      }
      if (this.skills) {
        this.skills.forEach((skill, i) => {
          if (skill.ar) {
            REQUEST_DATA.append(`skills[${i}][ar]`, skill.ar);
          }
          if (skill.en) {
            REQUEST_DATA.append(`skills[${i}][en]`, skill.en);
          }
        });
      }
      if (this.data.academic_year) {
        REQUEST_DATA.append("academic_year_id", this.data.academic_year.id);
      }
      if (this.data.image?.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.video?.file) {
        REQUEST_DATA.append("video", this.data.video.file);
      }

      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `courses/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/courses/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showCourse() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `courses/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Course.name_ar;
        this.data.name_en = res.data.data.Course.name_en;
        this.data.desc_ar = res.data.data.Course.description_ar;
        this.data.desc_en = res.data.data.Course.description_en;
        this.data.level = this.levels.find(
          (option) => option.value === res.data.data.Course.level
        );
        this.data.video.path = res.data.data.Course.video;
        this.data.image.path = res.data.data.Course.image;
        this.skills = res.data.data.Course.skills.map((skill) => ({
          ar: skill.name_ar,
          en: skill.name_en,
        }));
        this.data.academic_stage = res.data.data.Course.academic_stage;
        this.getAcademicYears(this.data.academic_stage.id);
        this.data.academic_year = res.data.data.Course.academic_year;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    async getAcademicStages() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "academic-stages?page=0&limit=0&is_active=1",
        });
        this.academic_stages = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getAcademicYears() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `academic-years?page=0&limit=0&is_active=1`,
        });
        this.academic_years = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectVideo(selectedVideo) {
      this.data.video = selectedVideo;
    },
    async getAcademicYears(stage_id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `academic-years?page=0&limit=0&is_active=1&academic_stage=${stage_id}`,
        });
        this.academic_years = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.showCourse();
    this.getAcademicStages();
  },
};
</script>
